import { useRef } from 'react';
import type { Canvas } from 'fabric';
import { FabricCanvasContext } from './fabricCanvasContextValue';

export { FabricCanvasContext } from './fabricCanvasContextValue';

export const FabricCanvasProvider = ({ children }: { children: React.ReactNode }) => {
  const canvasRef = useRef<Canvas | null>(null);
  return (
    <FabricCanvasContext.Provider value={{ canvasRef }}>
      {children}
    </FabricCanvasContext.Provider>
  );
};
